// Staff vs student is the only value `profiles.role` holds after Phase 2.
// Job titles live on `profiles.title`. Break-glass is `profiles.is_superuser`.

export const STAFF_ROLES = ['staff'] as const;

export type StaffRole = (typeof STAFF_ROLES)[number];

export function isStaffRole(role: string | null | undefined): role is StaffRole {
  return role === 'staff';
}
